import { render, staticRenderFns } from "./OrganizationLinkOrganization.vue?vue&type=template&id=539813c2"
import script from "./OrganizationLinkOrganization.vue?vue&type=script&lang=js"
export * from "./OrganizationLinkOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports